import Button from '@berlitz/button'
import { ArrowDown } from '@berlitz/icons'
import PortalLearningPathAttachment from '@classes/LearningPathAttachments'
import { DownloadContainer, DownloadSelection, EmptyDownloadContainer } from '@layouts/LearningPath/Chapter/style'
import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  setDownloadSelection: (arg0: boolean) => void
  downloadSelection: boolean
  filteredAttachments?: PortalLearningPathAttachment[]
}

const Download: React.FC<Props> = ({ setDownloadSelection, downloadSelection, filteredAttachments }) => {
  return filteredAttachments?.length ? (
    <DownloadContainer>
      <Button onClick={() => setDownloadSelection(!downloadSelection)} fullWidth outline>
        <FormattedMessage id="Download" />
        <ArrowDown color="brand01" size="sm" />{' '}
      </Button>
      {downloadSelection && (
        <DownloadSelection>
          <ul>
            {filteredAttachments?.map((Attachment, index) => (
              <li key={index}>
                <div onClick={() => window.open(Attachment.Url, '_blank')}>
                  <span>{Attachment.Name}</span>
                </div>
              </li>
            ))}
          </ul>
        </DownloadSelection>
      )}
    </DownloadContainer>
  ) : (
    <EmptyDownloadContainer />
  )
}

export default Download
